import { Routes } from '@angular/router';

import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { GuestLayoutComponent } from './layouts/guest-layout/guest-layout/guest-layout.component';

export const AppRoutes: Routes = [
  {
    path: '',
    redirectTo: 'auth/login',
    pathMatch: 'full',
  },
  {
    path : 'event', loadChildren : () => import('./modules/view-event/view-event.module').then(m => m.ViewEventModule)
  },
  {
    path : 'home', loadChildren : () => import('./modules/landing-page/landing-page.module').then(m => m.LandingPageModule)
  },
  {
    path : 'auth', loadChildren : () => import('./modules/auth/auth.module').then(m => m.AuthModule)
  },
  {
    path : 'privacy-policy', loadChildren : () => import('./modules/legal-documentation/legal-documentation.module').then(m => m.LegalDocumentationModule)
  },
  {
    path : 'terms-of-service', loadChildren : () => import('./modules/legal-documentation/legal-documentation.module').then(m => m.LegalDocumentationModule)
  },
  {
    path: '',
    component: AdminLayoutComponent,
    children: [
        {
      path: 'app',
      loadChildren: () => import('./layouts/admin-layout/admin-layout.module').then(x => x.AdminLayoutModule)
  }]},
  {
    path: '',
    component: GuestLayoutComponent,
    children: [
        {
      path: 'guest',
      loadChildren: () => import('./layouts/guest-layout/guest-layout.module').then(x => x.GuestLayoutModule)
  }]},
  {
    path: '**',
    redirectTo: 'auth'
    // redirectTo: 'auth'
  }
]
